module.exports = __webpack_public_path__ + "static/media/f_eyeshape_hooded_lightbrown.b34630a5.png";